import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { LocalAuthority } from "Globals/Models/LocalAuthority";

export class LocalAuthorityStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private localAuthorities: LocalAuthority[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.localAuthorities = initialState.localAuthorities;
    }

    @MobX.action
    public getLocalAuthorityName(localAuthorityId: string | null): string {
        if (localAuthorityId == "0" || localAuthorityId == null || localAuthorityId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => localAuthorityId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): LocalAuthority[] {
        return this.localAuthorities.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getLocalAuthorityOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
